import { ReactNode, useState } from "react";
import { IoCheckmark, IoCopyOutline, IoLink } from "react-icons/io5";
import Button from "../Button";
import RadixDialog from "./RadixDialog";
import classNames from "./ShareDialog.module.css";

type ShareDialogProps = {
  trigger: ReactNode;
  shareUrl: string;
  description: string;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
};

export default function ShareDialog(props: ShareDialogProps) {
  const [showCopied, setShowCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(props.shareUrl);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
  };

  return (
    <RadixDialog
      title="Share"
      trigger={props.trigger}
      content={
        <div className={classNames.ShareDialog}>
          <h3>{props.description}</h3>
          <div className={classNames.UrlContainer}>
            <IoLink className={classNames.LinkIcon} />
            {props.shareUrl}
          </div>
          <Button
            onClick={handleCopy}
            color="gray"
            backgroundColor="black"
            borderColor="dark-gray"
            style={{
              width: "100%",
            }}
          >
            {showCopied ? (
              <>
                <IoCheckmark />
                Copied!
              </>
            ) : (
              <>
                <IoCopyOutline />
                Copy link
              </>
            )}
          </Button>
        </div>
      }
      open={props.open}
      onOpenChange={props.onOpenChange}
    />
  );
}
